import React from "react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ title, sub, center = false, light = false, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : "text-start"} max-w-3xl ${className}`}>
    <Reveal>
      <h2 className={`font-display text-[32px] sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] ${light ? "text-white" : "text-green-light"}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.1}>
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-white/70" : "text-charcoal/60"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
